<app-site-selector
  #siteSelector
  [ctx]="ctx"
  (selectionChange)="onSiteSelectionChanged()"
  [showTags]="ctx != ADMIN_CONTEXT"
  [showOwner]="ctx == ADMIN_CONTEXT"
  [canAutoRefresh]="true"
  [isLoading]="isLoading"
  (refresh)="refresh()"
  (onPeriodEmitted)="onPeriodEmitted($event)"
  [datePickerSlug]="'logs'"
>
  <button
    class="btn btn-primary btn-download"
    title="{{ 'Download' | translate }}"
    (click)="downloadLogs()"
    [disabled]="isLoading"
  >
    <i class="icofont icofont-download"></i>
  </button>
  <a id="downloadAnchorElem" [hidden]="true"></a>
</app-site-selector>

<app-filters
  #filtersComponent
  [filtersInput]="filters"
  [isLoading]="isLoading"
  (filtersEmitter)="onFiltersChange($event)"
></app-filters>

<app-my-logs-graph
  #graphsComponent
  [isLoading]="isLoading"
  (refresh)="refresh()"
  (getLogs)="loadData()"
  (onPeriodEmitted)="onPeriodEmittedFromGraph($event)"
  (track)="createFiltersFromEvent($event)"
  [filters]="activeFilters"
  [ctx]="ctx"
  [totalRequests]="total"
  [breakdownPanelIsOpen]="ctx != ADMIN_CONTEXT"
/>

<div class="logs-container card mt-4">
  <ngx-datatable
    *ngIf="!isLoading; else loader"
    [messages]="{ emptyMessage: translate.instant('NoData') }"
    #logsTable
    class="material data-table table-responsive my-logs-table"
    [rows]="logs"
    [limit]="size"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="40"
    [scrollbarH]="logsTableMustScroll"
    [columnMode]="'force'"
  >
    <ngx-datatable-row-detail [rowHeight]="'auto'">
      <ng-template [typedTemplate]="rowType" let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
        <div style="padding: 20px">
          <json-viewer
            [json]="row.requestDetails"
            [expanded]="true"
            [highlightedFields]="row?.drivesList?.highlight"
          ></json-viewer>
          <div *ngIf="row?.drivesList?.drives?.length">
            <hr />
            <div class="bg-drives" style="text-align: left">
              <h6>{{ (row?.drivesList?.drives.length > 1 ? 'AnomaliesDetected' : 'AnomalyDetected') | translate }}</h6>
              <div style="line-height: 2">
                <div *ngFor="let d of row.drivesList.drives" class="flex-align-items">
                  <span
                    [innerHTML]="(d.category != d.label && d.category ? d.category + ' - ' : '') + d.label"
                    class="mr-1"
                  ></span>
                  &nbsp;
                  @if (d.description) {
                    <app-help
                      [tooltip]="(d.description | stripHtml) + appendAggravatingFactorDesc(d.label)"
                      tooltipPlacement="bottom"
                    />
                  }
                  @if (d.confidence) {
                    <span class="confidence"> {{ 'Confidence' | translateLabel }} {{ d.confidence }}%</span>
                  }
                </div>
                <div>
                  <a class="ogo-link" [href]="'#/sites/' + row.site + '?tab=expert'">
                    {{ 'ExpertSite' | translate }}
                    <i class="icofont icofont-external-link ml-1"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-row-detail>

    <ngx-datatable-column [maxWidth]="80" cellClass="cell">
      <ng-template [typedTemplate]="rowType" let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
        <span (click)="toggleExpandRow(row)" class="ogo-link" style="font-size: 12px">
          <a
            href="javascript:void(0)"
            class="ogo-link icon"
            [class.icon-angle-down]="expanded"
            [class.icon-angle-right]="!expanded"
            style="font-size: 11px; font-weight: bold"
            title="{{ 'Details' | translate }}"
          >
          </a>
          {{ 'Details' | translate }}
        </span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [minWidth]="lang == 'en' ? 195 : 180" [maxWidth]="210" cellClass="cell">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Date' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <span [title]="row.date | dateFormat: 'longMs'">{{ row.date | dateFormat }}</span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="2" cellClass="cell-no-pad">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Site' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #siteContent [typedTemplate]="rowType" let-row="row">
          <span title="{{ row.site }}">
            <small *ngIf="row.auditMode" class="label pull-left mr-2" style="background-color: #333">
              {{ 'Site.auditMode.label' | translate }}
            </small>
            <span>{{ row.site }}</span>
          </span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: 'site',
              cellValue: row.site,
              customContent: siteContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="3" cellClass="cell-no-pad">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Path' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #pathContent [typedTemplate]="rowType" let-row="row">
          <small
            *ngIf="row.rewriteOriginalPath"
            class="label pull-left mr-2"
            title=""
            placement="bottom"
            container="body"
            ngbTooltip="{{ 'RemplacedURL' | translate }}"
            style="background-color: #333; cursor: default"
            >R</small
          >
          <span title="{{ row.path }}">{{ row.path }}</span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.PATH,
              cellValue: row.path,
              customContent: pathContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column cellClass="cell-no-pad">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'IP' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #ipContent [typedTemplate]="rowType" let-row="row">
          <span class="flex-align-items">
            <div class="flex-ip-flag w-100" title="{{ row.clientIP + ' (' + row.countryCode + ')' }}">
              <div
                (click)="createFilter(LogFiltersType.IN, FiltersEnum.COUNTRY, row.countryCode)"
                *ngIf="row.countryCode"
                [attr.title]="row.countryName"
                class="pointer fi fi-{{ row.countryCode?.toLowerCase() }}"
              ></div>
              &nbsp;
              <div class="text-ellipsis ip-address" style="position: relative; top: -1px">{{ row.clientIP }}</div>
            </div>
          </span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.IP,
              cellValue: row.clientIP,
              customContent: ipContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="![RESPONSE_TIME, BANDWIDTH].includes(graphType)" cellClass="cell">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Credibility' | translate }}
        <app-help tooltipKey="CredibilityTooltip" tooltipPlacement="bottom" />
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <div
          #progressBar
          class="progress-bar-container progress-bar-gradient"
          [title]="row.rt && row.credibility !== null && row.credibility !== undefined ? row.credibility + '%' : ''"
        >
          <div
            [ngStyle]="{ width: 100 - (row.credibility || 0.1) + '%' }"
            style="min-width: 0.01em"
            class="progress-bar-cache"
          >
            <div
              *ngIf="CAUSES_CREDIBILITY_CLASS[row.cause]"
              [ngClass]="['progress-badge', CAUSES_CREDIBILITY_CLASS[row.cause]]"
            >
              {{ 'Cause.' + row.cause | translate }}
            </div>
          </div>
          <div
            *ngIf="row.credibility"
            [ngStyle]="{ top: '-10px', background: row.credibility < row.rt ? '#ff5370' : '' }"
            class="progress-bar-progressbar progress-{{ row.credibility }}"
          ></div>
          <div
            *ngIf="
              row.rt &&
              row.credibility !== null &&
              row.credibility !== undefined &&
              (row.action === ActionEnum.SUSPICIOUS || CAUSES_SHOW_CREDIBILITY_BAR[row.cause])
            "
            class="progress-bar-threshold"
            [ngStyle]="{ width: (progressBar.offsetWidth / 100) * row.rt + 'px' }"
          ></div>
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      *ngIf="![RESPONSE_TIME, BANDWIDTH].includes(graphsComponent.graphType)"
      cellClass="cell-no-pad"
    >
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Action.label' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #actionContent [typedTemplate]="rowType" let-row="row">
          <span title="{{ row.action | translate }}" class="action-{{ row.action }}">
            {{ 'Action.' + row.action | translate }}
            {{ row.auditMode && row.action == ActionEnum.BLOCKED ? '(N/A)' : '' }}
          </span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.ACTION,
              cellValue: row.action,
              customContent: actionContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      *ngIf="![RESPONSE_TIME, BANDWIDTH].includes(graphsComponent.graphType)"
      cellClass="cell-no-pad"
    >
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'MainCause' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #causeContent [typedTemplate]="rowType" let-row="row">
          <span title="{{ row.causeLabel }}">
            {{ row.causeLabel ?? '—' }}
          </span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: row.mainAttack ? FiltersEnum.ATTACK_CATEGORY : FiltersEnum.CAUSE,
              cellValue: row.mainAttack ? row.mainAttack.uid : row.cause,
              cellLabel: row.mainAttack?.name,
              customContent: causeContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      *ngIf="[RESPONSE_TIME, BANDWIDTH].includes(graphsComponent.graphType)"
      cellClass="cell-no-pad"
    >
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Method' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #methodContent [typedTemplate]="rowType" let-row="row">
          <span title="{{ row.method }}">{{ row.method }}</span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.METHOD,
              cellValue: row.method,
              customContent: methodContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column cellClass="cell-no-pad" [minWidth]="80" [maxWidth]="80">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'StatusCode' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #statusCodeContent [typedTemplate]="rowType" let-row="row">
          <span title="{{ row.code }}">{{ row.code }}</span>
          <i
            *ngIf="row.requestDetails?.responseHeaders?.['x-ogo-error']"
            class="icon-warning icofont icofont-warning"
            [ngbTooltip]="
              row.code == 499
                ? ('XOGOError499' | translate)
                : ('XOGOError' | translate) + row.requestDetails.responseHeaders['x-ogo-error']
            "
            placement="bottom"
            container="body"
            style="position: relative; top: -4px"
          ></i>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.STATUS_CODE,
              cellValue: row.code,
              customContent: statusCodeContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="graphsComponent.graphType == RESPONSE_TIME" cellClass="cell-no-pad">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'ResponseTime' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #responseTimeContent [typedTemplate]="rowType" let-row="row">
          <span title="{{ row.responseTimeMs }}">{{ row.responseTimeMs | duration }}</span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.RESPONSE_TIME_GTE,
              cellValue: Math.round(row.responseTimeMs),
              customContent: responseTimeContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [minWidth]="80"
      [maxWidth]="80"
      *ngIf="![RESPONSE_TIME, BANDWIDTH].includes(graphsComponent.graphType)"
      cellClass="cell"
    >
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Rule' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <div placement="left" container="body">
          {{ row.rulePriority ? '#' + row.rulePriority : '—' }}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="1" *ngIf="graphsComponent.graphType == BANDWIDTH" cellClass="cell-no-pad">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'ContentLengthHeader' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
        <ng-template #contentLengthContent [typedTemplate]="rowType" let-row="row">
          <span title="{{ row.contentLength }}">{{ row.contentLength | numberFormat }}</span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.CONTENT_LENGTH_GTE,
              cellValue: row.contentLength,
              customContent: contentLengthContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="graphsComponent.graphType == BANDWIDTH" cellClass="cell-no-pad">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'CacheStatus.TableHeader' | translate }}
      </ng-template>
      <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template let-i="rowIndex">
        <ng-template #cacheStatusContent [typedTemplate]="rowType" let-row="row">
          <span>{{ 'CacheStatus.' + row.cache | translate }}</span>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="
            datatableColumn;
            context: {
              row: row,
              cellSlug: FiltersEnum.CACHE_STATUS,
              cellValue: row.cache,
              customContent: cacheStatusContent,
            }
          "
        />
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template let-curPage="filters.index" let-pageSize="size">
        <small class="ogo-ngx-datatable-footer"
          >{{ 'Total.requests.' + (total > 1 ? 'plural' : 'singular') | translate: { requests: (total | number) } }}
        </small>
        <div class="flex-align-items ml-5">
          <small class="ogo-ngx-datatable-footer">{{ 'TotalPerPage' | translate }} :&nbsp;</small>
          <select
            class="form-control form-control-sm"
            [(ngModel)]="size"
            (change)="this.index = 0; loadLogsPage()"
            style="min-width: 60px"
          >
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        <datatable-pager
          [pagerLeftArrowIcon]="pager.PREV"
          [pagerRightArrowIcon]="pager.NEXT"
          [pagerPreviousIcon]="pager.FIRST"
          [pagerNextIcon]="pager.LAST"
          [page]="index + 1"
          [size]="size"
          [count]="total > 10000 ? 10000 : total"
          (change)="changePage($event)"
        >
        </datatable-pager>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>

  <ng-template #loader>
    <div class="component-loader">
      <div class="loader-track">
        <div class="loader-bar"></div>
      </div>
    </div>
  </ng-template>
</div>

<ng-template
  #datatableColumn
  let-row="row"
  let-slug="cellSlug"
  let-value="cellValue"
  let-label="cellLabel"
  let-customContent="customContent"
>
  <div>
    <div class="whole-cell text-ellipsis flex-align-items">
      <ng-container *ngTemplateOutlet="customContent; context: { row: row }" />
      <div
        class="track-container"
        [hidden]="
          (slug == FiltersEnum.CAUSE && row.mainAttack != undefined) ||
          (slug == FiltersEnum.ATTACK_CATEGORY && !row.mainAttack?.id)
        "
      >
        <div class="magnificient-container">
          <span
            (click)="filter(null, slug, value, label)"
            class="ogo-link gte"
            *ngIf="slug == FiltersEnum.RESPONSE_TIME_GTE || slug == FiltersEnum.CONTENT_LENGTH_GTE; else defaultZoomIn"
            >≥</span
          >
          <ng-template #defaultZoomIn>
            <i (click)="filter(LogFiltersType.IN, slug, value, label)" class="ogo-link icofont icofont-ui-zoom-in"></i>
          </ng-template>
          <i
            *ngIf="canFilterOut(slug)"
            (click)="filter(LogFiltersType.NOTIN, slug, value, label)"
            class="ogo-link icofont icofont-ui-zoom-out"
          ></i>
        </div>
      </div>
    </div>
  </div>
</ng-template>
